// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcx_a bie_wl","LoadingPlaceholder":"bcx_b bie_h","loading-placeholder":"bcx_c"};